module.exports = __webpack_public_path__ + "img/logo-3.d2e93ca5.png";